export default __webpack_public_path__ + "media/images/logo/media/toyokeizai-04305f72d313a5b46b860c6a9d5af181.jpg";